import React from "react";
import LooksOneRoundedIcon from "@mui/icons-material/LooksOneRounded";
import LooksTwoRoundedIcon from "@mui/icons-material/LooksTwoRounded";
import LooksThreeRoundedIcon from "@mui/icons-material/Looks3Rounded";
import LooksFourRoundedIcon from "@mui/icons-material/Looks4Rounded";
import LooksFiveRoundedIcon from "@mui/icons-material/Looks5Rounded";
import LooksSixRoundedIcon from "@mui/icons-material/Looks6Rounded";

const Button = (props) => (
  <button
    onClick={props.onClick}
    className={`${props.type == props.i
      ? props.i == 6
        ? ` border-purple-500 shadow-md shadow-purple-500`
        : props.i == 5
          ? ` border-sky-500 shadow-md shadow-sky-500`
          : props.i == 4
            ? ` border-green-500 shadow-md shadow-green-500`
            : props.i == 3
              ? ` border-yellow-500 shadow-md shadow-yellow-500`
              : props.i == 2
                ? ` border-orange-500 shadow-md shadow-orange-500`
                : ` border-red-500 shadow-md shadow-red-500`
      : ``
      } h-auto py-1.5 text-center bg-white rounded-full md:text-lg border-2 ${props.textColor
      } `}
  >
    {props.icon} {props.name}
  </button>
);

const ChoiceHuayType = (props) => {
  // console.log(props);
  return (
    <div>
      <div className="w-auto py-1 grid grid-cols-2 md:grid-cols-3 gap-1 text-base">
        {/* {localStorage.getItem("lotteryName") == "จับยี่กี" || localStorage.getItem("lotteryName") ==  "จับยี่กี 5G" ? (
          <></>
        ) : (
          <Button
            name="หกตัวตรง"
            textColor={"text-purple-500"}
            icon={<LooksSixRoundedIcon />}
            i={6}
            type={props.type}
            onClick={() => props.changeHuayType(6)}
          />
        )} */}
        {localStorage.getItem("lotteryName").split(' ').includes("JACKPOT") &&
          <>
            <Button
              name="ห้าตัว"
              textColor={"text-sky-500"}
              icon={<LooksFiveRoundedIcon />}
              i={5}
              type={props.type}
              onClick={() => props.changeHuayType(5)}
            />
            <Button
              name="สี่ตัว"
              textColor={"text-green-500"}
              icon={<LooksFourRoundedIcon />}
              i={4}
              type={props.type}
              onClick={() => props.changeHuayType(4)}
            />
          </>
        }
        {localStorage.getItem("lotteryName").split(' ').includes("JACKPOT") ||
          <>
            <Button
              name="สามตัว"
              textColor={"text-yellow-500"}
              icon={<LooksThreeRoundedIcon />}
              i={3}
              type={props.type}
              onClick={() => props.changeHuayType(3)}
            />
            <Button
              name="สองตัว"
              textColor={"text-orange-500"}
              icon={<LooksTwoRoundedIcon />}
              i={2}
              type={props.type}
              onClick={() => props.changeHuayType(2)}
            />
            <Button
              name="เลขวิ่ง"
              textColor={"text-red-500"}
              icon={<LooksOneRoundedIcon />}
              i={1}
              type={props.type}
              onClick={() => props.changeHuayType(1)}
            />
          </>
        }
      </div>
    </div>
  );
};

export default ChoiceHuayType;
